import { Component } from 'react';
import posthog from "posthog-js";
import StateConstants from "src/states/StateContstants";
import ApiHandler from "src/api/ApiHandler";
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler";
import ValuationTimeSeriesChart from './ValuationTimeSeriesChart';
import UserFeatureHelper from "src/utils/UserFeatureHelper";

interface ValuationHistorySectionProps {
    timeSeries: any;
    stateHandler: EventAdaptingStateHandler;
    apiHandler: ApiHandler;
}

interface ValuationHistorySectionState {
    isMobile: boolean;
    showTimeSeries: boolean;
    isGated: boolean;
}

export default class ValuationHistorySection extends Component<ValuationHistorySectionProps, ValuationHistorySectionState> {
    constructor(props: ValuationHistorySectionProps) {
        super(props);
        this.state = {
            isMobile: props.stateHandler.get(StateConstants.IS_MOBILE),
            showTimeSeries: props.stateHandler.get(StateConstants.SHOW_TIME_SERIES) || false,
            isGated: !UserFeatureHelper.hasFeature(props.stateHandler, UserFeatureHelper.DETAILED_VALUATIONS),
        };
        props.stateHandler.addListener(StateConstants.IS_MOBILE, (state: any) => {
            this.setState({ isMobile: state });
        });
        props.stateHandler.addListener(StateConstants.SHOW_TIME_SERIES, (state: any) => {
            this.setState({ showTimeSeries: state });
        });
        props.stateHandler.addListener(StateConstants.USER_FEATURES, () => {
            this.setState({
                isGated: !UserFeatureHelper.hasFeature(this.props.stateHandler, UserFeatureHelper.DETAILED_VALUATIONS),
            });
        });
    }

    toggleChart = () => {
        this.props.stateHandler.set(StateConstants.SHOW_TIME_SERIES, !this.state.showTimeSeries);
    };

    render() {
        const { timeSeries, stateHandler, apiHandler } = this.props;
        const { isMobile, showTimeSeries, isGated } = this.state;

        if (!timeSeries) return null;

        return (
            <div className="valuation-chart-module">
                {!isMobile && (
                    <div className="widget-header">
                        <h3 className="widget-title">Price Trends</h3>
                        <p className="widget-subtitle">Track how this property's value has changed</p>
                    </div>
                )}
                <div className={`chart-container ${isGated ? 'chart-preview-gated' : ''} ${!isGated && isMobile && !showTimeSeries ? 'chart-preview' : ''}`}>
                    <ValuationTimeSeriesChart
                        timeSeries={timeSeries}
                        stateHandler={stateHandler}
                        isPremium={UserFeatureHelper.hasFeature(stateHandler, UserFeatureHelper.ALL_TIME_CHART)}
                        onUpgradeClick={() => {
                            if (stateHandler.get(StateConstants.IS_LOGGED_IN)) {
                                apiHandler.createCheckout();
                            } else {
                                stateHandler.set(StateConstants.SHOW_LOGIN_MODAL, true);
                            }
                        }}
                    />
                    {isGated && (
                        <button className="chart-preview-expand" onClick={() => {
                            posthog?.capture("plans_opened", { source: "valuation_chart_blur" })
                            stateHandler.set(StateConstants.SHOW_PLAN_MODAL, true)
                        }}>
                            Unlock chart
                        </button>
                    )}
                    {!isGated && isMobile && !showTimeSeries && (
                        <button className="chart-preview-expand" onClick={this.toggleChart}>
                            See full chart
                        </button>
                    )}
                </div>
            </div>
        );
    }
}
